import { useTranslation } from "react-i18next";
import { IClinic, IDevice } from "src/Utils/Hooks/useGetDistributorInfo/useGetDistributorInfo";
import { usePartnerInfo } from "src/Utils/Hooks/usePartnerInfoContext";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { formatDateString } from "src/Utils/DateFormatting/DateFormattter";
import Button from "src/SharedComponents/Button/Button";
import { useState } from "react";
import UnassignDevice from "src/Components/Devices/UnassignDevice/UnassignDevice";
import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import clinicDevice from 'src/images/clinic_device.png';


export interface IClinicDevicesProps {
    clinic: IClinic;
    updateDevices: () => void
}

const ClinicDevices: React.FC<IClinicDevicesProps> = ({ clinic, updateDevices }) => {
    const { t } = useTranslation();
    const { distributorDetails } = usePartnerInfo();
    const clinicDevices = distributorDetails?.devices.filter(device => device.clinicId === clinic.clinicId);
    const [showUnassignDeviceConfirmDialog, setshowUnassignDeviceConfirmDialog] = useState<boolean>(false);
    const [device, setdevice] = useState<IDevice>();
    return (
        <div>
            {showUnassignDeviceConfirmDialog && device && distributorDetails &&
                <UnassignDevice
                    closeDialog={() => setshowUnassignDeviceConfirmDialog(false)}
                    deviceId={device.deviceId}
                    clinicId={clinic.clinicId}
                    clinicName={clinic.name ?? ''}
                    serialNumber={device.serialNumber}
                    distributorId={distributorDetails?.distributorId}
                    updateDevices={updateDevices}
                />
            }
          
                <div >
                      {
                clinicDevices && clinicDevices.length > 0 &&
                 <GridViewCollapase title={t('AssignedDevices')} titleImage={clinicDevice} id="aura-software-devices-assigned">
                <div style={{paddingLeft:'14px'}}>
                        {clinicDevices &&
                            <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                                <thead className={`${tableStyles.tableHead}`}>
                                    <tr key={'header'}>
                                        <th className={tableStyles.heading}>{t('SerialNumber')}</th>
                                        <th className={tableStyles.heading}>{t('DeviceModel')}</th>
                                        <th className={tableStyles.heading}>{t('SetUpDate')}</th>
                                        <th className={tableStyles.heading}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {clinicDevices?.sort((a, b) => (a.serialNumber.localeCompare(b.serialNumber))).map((device) => (
                                        <tr key={clinic.clinicId}>
                                            <td className={tableStyles.data}>{device.serialNumber}</td>
                                            <td className={tableStyles.data}>{t('AuraCaptureDevice')}</td>
                                            <td className={tableStyles.data}>{formatDateString(device.assignedDate)}</td>
                                            <td className={tableStyles.data} style={{ textAlign: 'end' }}>
                                                <Button
                                                    backgroundColor="none"
                                                    color="var(--primary-color)"
                                                    text={t("Unassign")}
                                                    borderColor="var(--primary-translucent)"
                                                    fontSize="12px"
                                                    width='160px'
                                                    borderStyle='solid'
                                                    borderWidth='2px'
                                                    fontWeight='600'
                                                    onClick={() => {
                                                        setdevice(device);
                                                        setshowUnassignDeviceConfirmDialog(true);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }
                    </div>
                </GridViewCollapase>
                 }
                </div>
           
        </div>
    );
};

export default ClinicDevices;
